/** @module csi/image/ImageEditorZoomin **/
define([
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/view/PluginFactory",
	"csi/view/ToolbarPluginButton",
	"csi/image/ImageEditorPluginMixin"
], function(lang,Action,PluginFactory,ToolbarPluginButton,ImageEditorPluginMixin) {

	return PluginFactory.declare("imagezoomin", [ToolbarPluginButton, ImageEditorPluginMixin], {
		/**
		 * Set the action for rotating
		 */
		constructor: function() {
			this.defAction = lang.mixin(new Action(), {
				m_id: "ImageEditorZoomin",
				m_onAction: "zoom",
				value: 0.1
			});
			this.defAction.setMaterialIcon("zoom_in");
			this.defAction.resolve();
		}
	});
});